// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Fpz9F","title":"styles_title__OB1Y0","subtitle":"styles_subtitle__cLAFU","footer":"styles_footer__BmKMW","spin":"styles_spin__2+k2A"};